export default __webpack_public_path__ + "static/media/G0860.Breech_03a_AllFours.1695379740000.4249dc81.jpg";